import React, { useEffect, useState } from "react";
import ExperienceMember from './ExperienceMember';
export default function CommunityMember(props) {


  const [isUser, setIsUser] = React.useState(false);

  const toggleFavorite = () => {
	  openMessageModal(props.hit.objectID, 'community');
  };

  const user_title = () => {
	  let title = '';

	  if (props.hit.directory_industry != '' || props.hit.directory_industry != 'Other') {
		  title = props.hit.directory_industry
	  }

	  if (props.hit.directory_location.trim() !== ',') {
		  title += ' in ' + props.hit.directory_location;
	  }

	  return title;
  }

  useEffect(() => {
    if (typeof window.is_user !== 'undefined') {
      if (window.is_user === 'True') {
        setIsUser(true)
      }
    }
  }, []);

  return (


    <div className="individuals__item">
															<div className="individual individual--alt">
																<div className="individual__content">
																	<div className="individual__head">
																		<h4>
																			{props.hit.name}
																		</h4>

																		<span>
																			• Community Member
																		</span>
																	</div>

																	<div className="individual__title">
																		<p>
																			{user_title()}
																		</p>
																	</div>
																</div>

																<aside className="individual__aside">
																	<ExperienceMember hit={props.hit} />

																	<div className="individual__actions">
																		<a href="#" className="btn btn--outline" onClick={toggleFavorite}>
																			Contact
																		</a>
																	</div>
																</aside>
															</div>
														</div>


  );
}
